import React from 'react';
import { Check, Shield, Moon, Star } from 'lucide-react';
import { HolographicButton } from './HolographicButton';
export function HeroSection() {
  return <section className="bg-warm-100 pt-0 pb-8 md:pb-12" data-id="element-121">
      {/* Super Headline Banner */}
      <div className="w-full bg-primary-500 text-white py-3 px-4 text-center" data-id="element-122">
        <p className="font-semibold text-sm md:text-base tracking-wide" data-id="element-123">
          DORMIR NO TIENE QUE SER UN SUEÑO IMPOSIBLE PARA PADRES PRIMERIZOS
        </p>
      </div>

      {/* Mobile: Mockup directly below banner */}
      <div className="md:hidden px-4 pt-8" data-id="element-124">
        <img src="https://cdn.magicpatterns.com/uploads/pVuzGSwn1C85XthMz4FzRv/Mockup_principal.webp" alt="Noches de Paz Manual" className="w-full max-w-xs mx-auto drop-shadow-xl rounded-xl" data-id="element-125" />
      </div>

      <div className="max-w-6xl mx-auto px-4 pt-8 md:pt-12" data-id="element-126">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-127">
          {/* Text Content */}
          <div className="space-y-6" data-id="element-128">
            <div className="inline-flex items-center gap-2 bg-primary-50 text-primary-600 px-4 py-2 rounded-full text-sm font-medium" data-id="element-129">
              <Moon className="w-4 h-4" data-id="element-130" />
              <span data-id="element-131">Sistema de 7 días para padres primerizos</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold leading-tight text-text-dark" data-id="element-132">
              Tu bebé puede dormir{' '}
              <span className="text-primary-500" data-id="element-133">6-8 horas seguidas</span> en
              solo 7 días
            </h1>

            <p className="text-lg text-text-body" data-id="element-134">
              El método diseñado para familias colombianas que funciona incluso
              con ruido de calle, vecinos y la abuela que llega sin avisar.
            </p>

            <ul className="space-y-3" data-id="element-135">
              {['Ritual nocturno de 15 minutos', 'Ventanas de sueño claras', 'Bloqueo sonoro estratégico'].map((bullet, i) => <li key={i} className="flex items-center gap-3" data-id="element-136">
                  <div className="bg-green-100 p-1 rounded-full" data-id="element-137">
                    <Check className="w-4 h-4 text-green-600" data-id="element-138" />
                  </div>
                  <span className="text-text-body" data-id="element-139">{bullet}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 pt-2" data-id="element-140">
              <HolographicButton href="#oferta" size="lg" data-id="element-141">
                Quiero dormir
              </HolographicButton>
              <div className="flex items-center gap-2 text-sm text-text-muted" data-id="element-142">
                <Shield className="w-4 h-4" data-id="element-143" />
                <span data-id="element-144">Garantía 7 días • Entrega inmediata</span>
              </div>
            </div>

            {/* Payment Logos */}
            <div className="flex items-center gap-4 pt-4 border-t border-warm-200" data-id="element-145">
              <span className="text-xs text-text-muted" data-id="element-146">Pago seguro:</span>
              <div className="flex items-center gap-3" data-id="element-147">
                <img src="https://cdn.magicpatterns.com/uploads/2g7JUoGT4Y31KBDxHq4Rp2/Visa_logo.png" alt="Visa" className="h-6 object-contain" data-id="element-148" />
                <img src="https://cdn.magicpatterns.com/uploads/j38mwo8M7pUiFefXPbFuZH/Mastercard_logo.png" alt="Mastercard" className="h-6 object-contain" data-id="element-149" />
                <img src="https://cdn.magicpatterns.com/uploads/1zV5ps1ooTUwFyijhJQzug/Nequi_logo.png" alt="Nequi" className="h-5 object-contain" data-id="element-150" />
                <img src="https://cdn.magicpatterns.com/uploads/oDaghU1m2dq4gvgie76GD1/efecty-logo.png" alt="Efecty" className="h-5 object-contain" data-id="element-151" />
              </div>
            </div>
          </div>

          {/* Desktop: Mockup Image */}
          <div className="hidden md:block relative" data-id="element-152">
            <div className="absolute inset-0 bg-primary-100/50 blur-3xl rounded-full scale-75" data-id="element-153"></div>
            <img src="https://cdn.magicpatterns.com/uploads/pVuzGSwn1C85XthMz4FzRv/Mockup_principal.webp" alt="Noches de Paz Manual" className="relative z-10 w-full max-w-md mx-auto drop-shadow-2xl rounded-xl" data-id="element-154" />
          </div>
        </div>
      </div>
    </section>;
}